<template>
  <el-dialog :visible.sync="innerVisible" :title="$t('SeaExport.BackFillCabinBerth')" width="400px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" label-width="85px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label-width="0" class="auto-width">
            <el-radio-group v-model="radioType" no="1" @change="cabinRadioBtnChangeHandler">
              <el-radio :label="4">{{ $t('SeaExport.BookingSuccess') }}</el-radio>
              <el-radio :label="3">{{ $t('SeaExport.ToBeConfirmed') }}</el-radio>
              <el-radio :label="2">{{ $t('SeaExport.BookingFail') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-show="changeGroup" :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Vessel')" class="auto-width">
            <cargo-advance-select
              no="2"
              :select-type="selectTypeNames.static_data_Vessel"
              :cache="false"
              filterable
              :allow-create="true"
              :default-value="job.vessel"
              :static-options="vesselList"
              @parentCallBack="p=>{onVesselSelectionChange(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Voyage')" class="auto-width">
            <el-select
              ref="voyageFlight"
              v-model="job.voyageFlight"
              no="3"
              :allow-create="true"
              filterable
              clearable
              @focus="txtVoyageFocusInHandler()"
              @blur="txtVoyageFocusOutHandler()"
              @visible-change="onVisibleChange"
            >
              <el-option
                v-for="(item,index) in voyages"
                :key="index"
                :label="item.voyageNo"
                :value="item.voyageNo"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_IMO')">
            <el-input v-model="job.vesselIMO" no="4" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.DateOfDeparture')" class="auto-width">
            <el-date-picker
              v-model="job.etd"
              no="5"
              type="date"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            />&nbsp;
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="S/O No.">
            <so-no-input v-model="job.soNo" no="6" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.MblNo2')">
            <el-input v-model="job.mbl" no="7" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.BookingNo')">
            <el-input v-model="job.bookingNo" no="8" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.ShippingCompanyContractNo')">
            <el-input v-model="job.scNo" no="9" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.BookingShipCallSign')">
            <el-input v-model="job.vesselCode" no="10" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')">
            <el-input
              v-model="job.remarks"
              no="11"
              type="textarea"
              :rows="4"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button no="12" type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button no="13" @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSeaExportJobByUuid } from '@/api/seaExport/seaExportJob'
import { Vessel } from '@/class/model/mdm/Vessel'
import { Voyage } from '@/class/model/mdm/Voyage'
import { loadSpecificBasicInfo } from '@/api/cache'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import { updateOrderCabinAudit } from '@/api/seaExport/seaExportJob'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'OpVerifyFrameDialog',
  components: { soNoInput, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, default: () => false },
    context: { type: Object, required: true },
    jobModel: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      job: {
        vesselCode: '',
        scNo: 'OS',
        bookingNo: '',
        mbl: '',
        remarks: '',
        soNo: '',
        etd: '',
        voyageFlight: '',
        vessel: '',
        vesselIMO: ''
      },
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      changeGroup: true,
      vesselList: [],
      voyages: [],
      currentVessel: null,
      radioType: 4 // 默认选中项
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.init()
        } else {
          this.innerVisible = false
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    cabinRadioBtnChangeHandler() {
      const cabinState = this.radioType
      this.changeGroup = cabinState === 4 || cabinState === 3
    },
    async init() {
      Object.assign(this.job, this.jobModel)
      const dbJob = await getSeaExportJobByUuid(this.jobModel.uuid).then((res) =>
        res.data ? res.data : null
      )
      if (dbJob) Object.assign(this.job, dbJob)
      this.setRadioBth()
      this.innerVisible = true
      this.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
    },
    setRadioBth() {
      const cabinBtn = parseInt(this.job.cabinState)
      if (!cabinBtn || cabinBtn === 4) {
        this.radioType = 4
        this.changeGroup = true
        return
      }
      if (cabinBtn === 3) {
        this.radioType = 3
        this.changeGroup = true
        return
      }
      if (cabinBtn === 2) {
        this.radioType = 2
        this.changeGroup = false
        return
      }
      this.radioType = 4
    },
    /**
     * 实现自动带出V.，并且录入时追加数据，而不是覆盖
     */
    txtVoyageFocusInHandler() {
      let value = 'V.'
      if (this.job.voyageFlight) {
        value = this.job.voyageFlight
        this.job.voyageFlight = ''
      }
      this.$nextTick(() => {
        this.job.voyageFlight = value
        const elSelect = this.$refs.voyageFlight
        const innerInput = elSelect.$children[0].$refs.input
        innerInput.value = this.job.voyageFlight
      })
    },
    async txtVoyageFocusOutHandler() {
      const job = this.job
      const validateCode = /^[A-Za-z0-9\.]+$/
      const elSelect = this.$refs.voyageFlight
      const innerInput = elSelect.$children[0].$refs.input
      if (!validateCode.test(innerInput.value)) {
        this.$message.warning(this.$t('SeaExport.VoyageOnlyNum'))
        job.voyageFlight = ''
        return
      }
      job.voyageFlight = innerInput.value
      if (job.bookingTerm === 'SB' && job.destinationPortCode && job.destinationPortCode.length && job.carrierId) {
        if (job.vessel && job.voyageFlight.length > 2) {
          const ediCode = await Vessel.getEDICode(job.vessel, job.voyageFlight, job.destinationPortCode, job.carrierId)
          if (ediCode) {
            job.vesselCode = ediCode
          }
        }
      }
    },
    /**
     * vessel change
     */
    onVesselSelectionChange(data) {
      this.currentVessel = data
      this.job.vessel = data.value
      if (data.value && data.uuid) {
        this.job.vesselIMO = this.currentVessel.imoCode
      } else {
        this.job.vesselIMO = ''
      }
      this.getVoyageByVessel()
    },
    async getVoyageByVessel() {
      if (this.currentVessel && this.currentVessel.vesselId) {
        this.voyages = await Voyage.getVoyage(this.currentVessel.vesselId)
      } else {
        this.voyages = []
      }
    },
    handleSubmit() {
      const form = {}
      form.cabinState = this.radioType
      if (this.radioType === 4 || this.radioType === 3) {
        form.vessel = this.job.vessel
        form.voyageFlight = this.job.voyageFlight
        form.vesselIMO = this.job.vesselIMO
        form.soNo = this.job.soNo
        form.mbl = this.job.mbl
        form.bookingNo = this.job.bookingNo
        form.scNo = this.job.scNo
        form.vesselCode = this.job.vesselCode
        form.etd = this.job.etd
      }
      form.remarks = this.job.remarks
      form.uuid = this.job.uuid
      this.loading = getLoading()
      updateOrderCabinAudit(form, this.$store.getters.currentOfficeId).then(res => {
        this.$message.success(this.$t('SeaExport.UpdateSuccess'))
        this.$emit('reloadFunc', res.data)
      }).finally(() => {
        this.loading.close()
        this.handleClose()
      })
    },
    handleClose() {
      this.innerVisible = false
    },
    onVisibleChange(e) {
      if (e) {
        this.setSelectedLabel()
      }
      this.$emit('visible-change', e)
    },
    setSelectedLabel() {
      this.$nextTick(() => {
        const select = this.$refs.voyageFlight
        if (select.query) {
          select.selectedLabel = select.query
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .cargo-form-dialog{
    .el-dialog{
      &__header,&__body,&__footer{
        padding:10px 15px!important;
      }
      &__title{
        vertical-align: middle;
      }
      &__headerbtn{
        top:15px;
        right:15px;
      }
    }
  }
  .cargo-form{
    .el-form-item {
      &.label-none {
        .el-form-item__content{
          margin-left: 0;
        }
      }
    }
  }
</style>
